import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import { ViewportElementExtension } from '@blocksuite/affine-shared/services';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import { css, html } from 'lit';
import { literal } from 'lit/static-html.js';

import { EdgelessRootService } from './edgeless/edgeless-root-service';
import { renderEdgelessWidgets } from './edgeless/render-widgets';
import { EdgelessRootPreviewBlockComponent } from './preview/edgeless-root-preview-block';

export function rootViewingEffects() {
  if (!customElements.get('affine-edgeless-root-preview'))
    customElements.define(
      'affine-edgeless-root-preview',
      EdgelessRootPreviewBlockComponent
    );
}
export function edgelessRootViewingExtensions() {
  return [
    EdgelessRootService,
    ViewportElementExtension('.affine-edgeless-viewport'),
  ];
}
export const rootViewingBlock = () =>
  BlockViewExtension('affine:page', literal`affine-edgeless-root-preview`);
export class RootViewingExtension extends ViewExtensionProvider {
  override name = 'root-viewing';
  override effect() {
    super.effect();
    rootViewingEffects();
    if (!customElements.get('affine-edgeless-root-viewing'))
      customElements.define(
        'affine-edgeless-root-viewing',
        EdgelessViewingRootBlockComponent
      );
  }
  override setup(context: ViewExtensionContext) {
    super.setup(context);
    context.register([
      FlavourExtension('affine:page'),
      ...edgelessRootViewingExtensions(),
      BlockViewExtension('affine:page', literal`affine-edgeless-root-viewing`),
    ]);
  }
}

/** Native viewing root with presence; the standard preview remains unchanged. */
export class EdgelessViewingRootBlockComponent extends EdgelessRootPreviewBlockComponent {
  static override styles = css`
    ${EdgelessRootPreviewBlockComponent.styles}
    affine-edgeless-root-viewing {
      display: block;
      height: 100%;
      user-select: none;
    }
    affine-edgeless-root-viewing .widgets-container {
      position: absolute;
      inset: 0;
      pointer-events: none;
      contain: size layout;
    }
  `;
  override renderBlock() {
    return html`${super.renderBlock()}
      <div class="widgets-container">
        ${renderEdgelessWidgets(this.widgets)}
      </div>`;
  }
}
